<template>
  <div class="quick-prompt-message">
    <div class="description">
      <TextBody :text="title" tag="span" :body-type="2" weight="medium" className="title" />
      <div class="answer-filter-container">
        <TextBody :text="`${answers} ${t('common.answers')}`" tag="span" :body-type="3" weight="medium" />
        <TextBody :text="`${filtersCount || 0} ${t('common.filters')}`" tag="span" :body-type="3" weight="medium" />
      </div>
    </div>
    <BbBtn size="x-small" type="icon" icon="preview" icon-size="small" no-background @click="previewOpened = true" />
  </div>
  <PromptCardPreviewModal
    :opened="previewOpened"
    :content="cardContent"
    :title="title"
    :filters="filters"
    :versionContentId="versionContentId"
    :promptCardVariables="promptCardVariables"
    title-key="errors.somethingWentWrong"
    warning-message-key="collections.collectionNotFound"
    @update:open="previewOpened = false"
    @execute:action="previewOpened = false"
  />
</template>

<script>
import { ref, computed } from 'vue';
import { marked } from 'marked';
import { useI18n } from 'vue-i18n';

import TextBody from '~/components/common/TextBody.vue';
import PromptCardPreviewModal from '~/components/conversation/quickPrompting/PromptCardPreviewModal.vue';
import { useSanitize } from '~/composables/useSanitize';

export default {
  components: { PromptCardPreviewModal, TextBody },
  props: {
    message: {
      type: Object,
      default: () => {},
      required: true,
    },
  },
  setup(props) {
    const { sanitize } = useSanitize();
    const { t } = useI18n();

    const previewOpened = ref(false);
    const cardContent = computed(() => sanitize(marked.parse(props.message.message || '')));
    const answers = computed(() => props.message?.promptCardVariables?.filter((item) => item.value)?.length || 0);
    const filters = computed(() => props.message?.filters);
    const filtersCount = computed(
      () =>
        props.message?.filters.flatMap((filter) => (Array.isArray(filter.value) ? filter.value : [filter.value]))
          ?.length,
    );
    const versionContentId = computed(() => props.message?.versionContentId || null);
    const title = computed(() => props.message?.promptCardTitle || null);
    const promptCardVariables = computed(() => props.message?.promptCardVariables || null);

    return {
      previewOpened,
      cardContent,
      t,
      filters,
      filtersCount,
      answers,
      versionContentId,
      title,
      promptCardVariables,
    };
  },
};
</script>

<style scoped lang="scss">
.quick-prompt-message {
  width: 278px;
  border-radius: 99px;
  border: 1px solid $bb-neutral-4;
  background: $bb-neutral-0;
  display: flex;
  padding: $bb-spacing-3 $bb-spacing-6;
  align-items: center;
  justify-content: space-between;

  .description {
    display: flex;
    flex-direction: column;
    gap: $bb-spacing-1;

    :deep(.body-2.font-weight-medium.title) {
      font-weight: 600 !important;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      width: 208px;
    }

    .answer-filter-container {
      display: flex;
      gap: $bb-spacing-4;
    }
  }

  :deep(.v-btn__content) {
    i {
      color: $bb-primary-3;
    }
  }
}
</style>
